import React from "react";
import { BookOpen } from "lucide-react";
import { TransformedProfileData } from "@/types/publicProfile";
import { Section } from "./Section";

interface PublicationsSectionProps {
  publications: TransformedProfileData["sections"]["publications"]["items"];
}

export const PublicationsSection: React.FC<PublicationsSectionProps> = ({
  publications,
}) => {
  return (
    <Section
      id="publications"
      title="Publications"
      icon={<BookOpen className="h-5 w-5" />}
    >
      <div className="grid gap-4 md:grid-cols-2">
        {publications
          .filter((pub) => pub.privacy.isVisible)
          .map((publication) => (
            <article key={publication.id} className="card-apple p-5">
              <h3 className="text-base font-semibold mb-2">
                {publication.title}
              </h3>
              {publication.publisher && (
                <div className="text-sm text-secondary mb-2">
                  {publication.publisher}
                </div>
              )}
              <div className="text-xs text-tertiary mb-2">
                {new Date(publication.publishDate).toLocaleDateString()}
                {publication.type && (
                  <span className="ml-2 pill-apple text-xs capitalize">
                    {publication.type}
                  </span>
                )}
              </div>
              {publication.description && (
                <p className="text-sm text-secondary mb-3">
                  {publication.description}
                </p>
              )}
              {publication.authors && publication.authors.length > 0 && (
                <div className="text-xs text-tertiary mb-2">
                  Authors: {publication.authors.join(", ")}
                </div>
              )}
              {publication.url && (
                <a
                  href={publication.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-xs text-primary hover:underline"
                >
                  Read Publication
                </a>
              )}
            </article>
          ))}
      </div>
    </Section>
  );
};
